import {VcrEntity} from './entity';
import {AccessType, Role} from '@app/modules/shared/data/constants';

export class User extends VcrEntity<any> {
  get id(): number {
    return this.data.id;
  }

  set id(idValue) {
    this.data.id = idValue;
  }

  get firstName(): string {
    return this.data.firstName;
  }

  get lastName(): string {
    return this.data.lastName;
  }

  get name(): string {
    return this.data.name;
  }

  get nickname(): string {
    return this.data.nickname;
  }

  get email(): string {
    return this.data.email;
  }

  get accessType(): AccessType {
    return this.data.accessType;
  }

  get identity(): string {
    return this.data.identity;
  }

  get role(): Role {
    return this.data.role;
  }

  get personalColor(): string {
    return this.data.personalColor;
  }

  get isGuest(): boolean {
    return this.data.isGuest;
  }

  get connectionTimestamp(): number {
    return this.data.connectionTimestamp;
  }
}
